var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomCasinoGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_51631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175 141.467C174.237 142.521 173.579 143.671 172.694 144.603C170.339 147.066 167.862 149.416 165.482 151.864C164.248 153.136 162.827 153.727 161.048 153.711C156.509 153.67 151.977 153.695 147.438 153.711C146.764 153.711 146.204 153.727 146.065 152.836C144.961 145.973 143.824 139.117 142.703 132.254C142.687 132.165 142.72 132.068 142.744 131.865C143.15 131.841 143.581 131.792 144.003 131.792C153.074 131.792 162.145 131.825 171.216 131.76C172.986 131.752 174.229 132.303 174.992 133.883V141.484L175 141.467Z",
    fill: "url(#paint0_linear_116_51631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.403 33.0161C118.828 32.9999 81.253 32.9999 43.6779 33.0161C35.2891 33.0161 29.7426 38.5747 29.7426 46.9209V122.879C30.0593 122.936 30.246 122.992 30.4328 122.992C39.65 123 48.8752 122.992 58.1005 123.017C58.9207 123.025 59.14 122.636 59.3674 121.963C62.7375 111.948 71.2075 105.676 81.724 105.603C93.9215 105.514 106.119 105.514 118.317 105.595C128.849 105.668 137.36 111.94 140.673 121.939C141.006 122.936 141.526 123.017 142.379 123.017C151.206 122.992 160.041 123 168.877 123C169.299 123 169.73 122.968 170.314 122.936V46.9533C170.314 38.5829 164.776 33.0161 156.403 33.0161ZM101.718 41.2893C108.174 41.7106 113.769 44.0605 118.593 48.2336C116.636 50.1945 114.703 52.123 112.754 54.0678C109.587 51.4343 105.908 49.9109 101.718 49.5139V41.2893ZM98.3799 41.2893V49.5139C94.2139 49.9109 90.5189 51.4262 87.3436 54.0597C85.3946 52.1149 83.4619 50.1945 81.5048 48.2417C86.3285 44.0605 91.9319 41.7268 98.3799 41.2893ZM79.0604 50.6726C81.0175 52.6254 82.9503 54.5458 84.8993 56.4987C82.2762 59.6508 80.7414 63.3214 80.3435 67.5026H72.1008C72.5312 61.0688 74.8782 55.4777 79.0604 50.6726ZM72.1008 70.8411H80.3516C80.7414 75.0141 82.2762 78.6848 84.9074 81.845C82.9584 83.7897 81.0256 85.7182 79.0604 87.6711C74.8782 82.8579 72.5312 77.2749 72.1008 70.8411ZM98.3717 97.0463C91.9319 96.6087 86.3367 94.2832 81.4885 90.0939C83.4538 88.1411 85.3703 86.2206 87.3355 84.2678C90.5027 86.9013 94.1895 88.4328 98.3717 88.8217V97.0463ZM83.5756 69.188C83.5431 60.145 90.9493 52.747 100.045 52.7308C109.124 52.7227 116.538 60.1207 116.522 69.1799C116.506 78.231 109.189 85.5481 100.077 85.6048C91.0386 85.6615 83.5999 78.2634 83.5756 69.188ZM101.726 97.0463V88.8217C105.875 88.4328 109.57 86.9175 112.754 84.2759C114.703 86.2206 116.636 88.1411 118.593 90.102C113.769 94.2751 108.174 96.6168 101.726 97.0463ZM121.013 87.6549C119.064 85.7101 117.139 83.7816 115.206 81.845C118.211 77.7692 118.958 75.9703 119.77 70.8411H127.932C127.859 75.6624 125.715 82.5013 121.013 87.6549ZM127.923 67.5026H119.754C119.551 65.4687 119.096 63.4916 118.308 61.6117C117.521 59.7318 116.465 58.022 115.19 56.4906L120.996 50.6969C124.602 54.0435 128.354 63.0946 127.923 67.5026Z",
    fill: "url(#paint1_linear_116_51631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.636 155.567C136.117 146.354 134.469 137.157 133.096 127.919C131.748 118.747 124.927 114.404 118.528 114.371C106.176 114.314 93.8323 114.282 81.4805 114.387C74.261 114.452 68.414 119.63 67.2365 126.696C65.6367 136.241 64.045 145.787 62.4696 155.34C61.6331 160.421 64.3374 164.991 69.0393 166.498C73.8225 168.038 78.5245 165.988 80.8958 161.312C82.7229 157.714 84.542 154.108 86.3124 150.478C86.7103 149.652 87.2056 149.393 88.1071 149.401C96.0574 149.433 104.016 149.441 111.966 149.393C112.981 149.384 113.42 149.773 113.826 150.608C115.62 154.287 117.44 157.941 119.324 161.571C121.143 165.088 124.115 166.814 127.298 166.944C134.136 166.903 138.619 161.588 137.636 155.567ZM86.7834 136.249C84.3715 136.233 82.4468 134.297 82.455 131.89C82.4631 129.532 84.4527 127.522 86.8077 127.506C89.2034 127.49 91.2742 129.589 91.2255 131.987C91.1767 134.378 89.2034 136.274 86.7834 136.249ZM113.168 136.249C110.756 136.241 108.815 134.313 108.807 131.914C108.807 129.556 110.772 127.547 113.135 127.506C115.531 127.474 117.618 129.556 117.586 131.963C117.553 134.353 115.58 136.266 113.168 136.249Z",
    fill: "url(#paint2_linear_116_51631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8127 153.663C48.4367 153.663 43.215 153.727 38.0014 153.606C37.0351 153.582 35.8819 153.014 35.1591 152.334C32.1463 149.498 29.1903 146.572 26.3724 143.542C25.6496 142.764 25.2355 141.492 25.1137 140.406C24.9106 138.575 25.0325 136.711 25.0649 134.863C25.1055 132.967 26.1856 131.809 28.0534 131.801C37.6198 131.768 47.1861 131.784 56.7524 131.784C56.9392 131.784 57.126 131.841 57.4508 131.898C56.2327 139.174 55.0308 146.394 53.8127 153.663Z",
    fill: "url(#paint3_linear_116_51631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.39 61.3687C103.366 61.4902 103.342 61.6442 103.301 61.7819C101.839 66.8949 100.369 72.0161 98.9077 77.1291C98.7128 77.8016 98.2256 78.1663 97.6409 78.0771C96.9669 77.9718 96.5365 77.356 96.7232 76.6996C97.1536 75.16 97.6003 73.6286 98.0388 72.089C99.0864 68.4345 100.134 64.78 101.182 61.1256C101.344 60.5584 101.75 60.2342 102.294 60.2423C102.798 60.2423 103.212 60.5746 103.35 61.0607C103.374 61.1499 103.382 61.2471 103.399 61.3687H103.39Z",
    fill: "url(#paint4_linear_116_51631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.595 69.1805C109.522 69.0995 109.457 69.0346 109.392 68.9698C108.247 67.8273 107.102 66.6847 105.957 65.5422C105.632 65.2181 105.518 64.8373 105.648 64.3997C105.77 63.9864 106.07 63.7271 106.493 63.638C106.874 63.557 107.207 63.6623 107.475 63.9297C108.986 65.4288 110.488 66.9197 111.982 68.435C112.413 68.8726 112.413 69.5289 111.982 69.9665C110.488 71.4736 108.986 72.9727 107.467 74.4637C107.012 74.9093 106.322 74.8769 105.892 74.4313C105.469 73.9856 105.469 73.313 105.924 72.8593C107.069 71.7086 108.23 70.558 109.384 69.4074C109.449 69.3425 109.514 69.2696 109.587 69.1967L109.595 69.1805Z",
    fill: "url(#paint5_linear_116_51631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.454 69.1801C90.5271 69.2611 90.592 69.326 90.657 69.3908C91.7939 70.5252 92.9227 71.6515 94.0596 72.786C94.4088 73.1263 94.5469 73.5233 94.3926 73.9933C94.1408 74.7712 93.1744 75.0143 92.5654 74.4471C92.1269 74.0338 91.7127 73.6044 91.2904 73.1749C90.2509 72.1377 89.2034 71.1005 88.1639 70.0552C87.5954 69.488 87.5954 68.8641 88.1639 68.2969C89.6013 66.8545 91.0468 65.4203 92.4923 63.9779C92.7847 63.6862 93.1176 63.5404 93.5318 63.6133C93.9703 63.6943 94.2789 63.9536 94.4007 64.3831C94.5306 64.8207 94.4169 65.2096 94.0921 65.5256C92.9471 66.6682 91.802 67.8107 90.657 68.9532C90.592 69.018 90.5271 69.091 90.454 69.1639V69.1801Z",
    fill: "url(#paint6_linear_116_51631)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_51631",
    x1: 158.85,
    y1: 131.76,
    x2: 158.85,
    y2: 153.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_116_51631",
    x1: 100.028,
    y1: 33.0039,
    x2: 100.028,
    y2: 123.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_116_51631",
    x1: 100.045,
    y1: 114.318,
    x2: 100.045,
    y2: 167.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_116_51631",
    x1: 41.2249,
    y1: 131.78,
    x2: 41.2249,
    y2: 153.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_116_51631",
    x1: 100.039,
    y1: 60.2422,
    x2: 100.039,
    y2: 78.0904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_116_51631",
    x1: 108.942,
    y1: 63.6113,
    x2: 108.942,
    y2: 74.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_116_51631",
    x1: 91.0964,
    y1: 63.5947,
    x2: 91.0964,
    y2: 74.7579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_51631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 134,
    fill: "white",
    transform: "translate(25 33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCasinoGame);
export default __webpack_public_path__ + "static/media/Custom_Casino_Game.24d6adc0a21c52b5b2127b5086bd0b15.svg";
export { ForwardRef as ReactComponent };